import { createFileRoute, notFound } from '@tanstack/react-router';

import { lazyScreen } from '@/shared/screen';

// A tela real de Produtos de Cobrança sobre o MSW do módulo, sem login (T1.C). Só em dev: em produção
// a rota responde 404 e o chunk nem é pedido. A tela navega num roteador próprio, no `#` da URL.
export const Route = createFileRoute('/dev/produtos-cobranca')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- notFound() é o contrato do TanStack Router.
    if (!import.meta.env.DEV) throw notFound();
  },
  component: import.meta.env.DEV ? lazyScreen(() => import('./-produtos-cobranca-catalog'), 'ProdutosCobrancaCatalog') : () => null,
});
